// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"

type SubfilterObject = {
    // enumGenericFilter or false
    label?: React.ComponentType | false
    subfilters: React.ComponentType[]
}
type Subfilters = Array<React.ComponentType | React.ComponentType[] | SubfilterObject>

interface MultiFilterProps {
    uniqueFilterGroupId: string
    uniqueFlvId: string
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm?: string
    // from app/static/frontend/search-new/components/Filter/index.js
    setFilterContainsSearchFilterTerm?: () => void
    // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
    setFilterGroupContainsSearchFilterTerm?: () => void
    // from Filters.js
    subfilters: Subfilters
}

export default class MultiFilter extends Component<MultiFilterProps> {
    static propTypes = {
        // from Filter/index (shared)
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        // from app/static/frontend/search-new/components/Filter/index.js
        setFilterContainsSearchFilterTerm: PropTypes.func,
        // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
        setFilterGroupContainsSearchFilterTerm: PropTypes.func,
        // from Filters.js
        subfilters: PropTypes.array.isRequired,
    }

    renderFilters() {
        const renderFilter = ({ filter, index }) => {
            const FilterComponent = filter

            return (
                <FilterComponent
                    // some filters share uniqueFilterId, so include index in React render key
                    key={`${FilterComponent.defaultProps.uniqueFilterId}-${index}`}
                    uniqueFilterGroupId={this.props.uniqueFilterGroupId}
                    uniqueFlvId={this.props.uniqueFlvId}
                    isSubfilter
                    searchFilterTerm={this.props.searchFilterTerm}
                    setFilterContainsSearchFilterTerm={this.props.setFilterContainsSearchFilterTerm}
                    setFilterGroupContainsSearchFilterTerm={this.props.setFilterGroupContainsSearchFilterTerm}
                />
            )
        }
        const renderSubfilters = ({ label, subfilters }: SubfilterObject) => {
            const LabelComponent = label

            return (
                <div className="filter-header-design-system">
                    {LabelComponent && <LabelComponent />}
                    <div
                        style={{
                            display: "flex",
                            gap: "7px",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                        }}
                    >
                        {subfilters.map((subfilter, j) => {
                            return renderFilter({
                                filter: subfilter,
                                index: j,
                            })
                        })}
                    </div>
                </div>
            )
        }

        return this.props.subfilters.map((component, i) => {
            if (Array.isArray(component)) {
                return renderSubfilters({
                    subfilters: component,
                })
            } else if (typeof component === "object" && !React.isValidElement(component)) {
                const label = (component as SubfilterObject).label
                const subfilters = (component as SubfilterObject).subfilters

                if (label && subfilters.length) {
                    return renderSubfilters({
                        label,
                        subfilters,
                    })
                }
            } else {
                return renderFilter({
                    filter: component,
                    index: i,
                })
            }

            return undefined
        })
    }

    render() {
        return <div>{this.renderFilters()}</div>
    }
}
